import { useState } from 'react';
import { useDataContext } from '../../../DataProvider/DataContext';
import { VariantList } from './VariantList';
import { FlexColumnDiv, FlexRowDiv, HeaderDiv } from '../../../styledComponents/Components.styles';
import LabelField from '../../formFields/LabelField';
import palette from '../../../../utilities/palette';
import { Accordion, AccordionDetails, AccordionSummary, ButtonBase } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { extractMachineErrors } from '../../../../utilities/validationErrorExtraction';

/**
 * 
 * @param machineList: list of machineList
 * @param setMachineList: function to set the list of bundles
 * @returns a list of machine components 
 */
const MachineList = ({ 
    moduleInformation,
    machineList, 
    setMachineList, 
    machineListErrors, 
    setMachineListErrors,
    projectKey,
    moduleName,
}) => {
    const [expanded, setExpanded] = useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const { ECUData} = useDataContext();
    const {
        fieldsWithErrorList,
        variantWithErrorList,
        clusterWithErrorList,
        criteriaWithErrorList
    } = extractMachineErrors(machineListErrors || []);

    const machineToVariantData = ECUData.current.machineToVariantData || {};
    const machineToVariantDatKey = Object.keys(machineToVariantData);

    return (
        <div style={{marginLeft: '20px'}}>
            {machineList.map((machineEntry, machineIndex) => 
            {
                const machineId = machineToVariantDatKey.find(key => 
                    machineToVariantData[key].machineName === machineEntry.machineName &&
                    "0x" + machineToVariantData[key].canDiagRxId === machineEntry.canDiagRxId
                );
                const machineDescription = machineId ? machineToVariantData[machineId]?.machineDescription || "N/A" : "N/A";
                return (
                <HeaderDiv
                    id={`machineList_machine_${machineIndex}`}
                    key={`machineList_machine_${machineEntry.machineName}_${machineEntry.machineType}`}
                >
                    <Accordion
                        slotProps={{ transition: { unmountOnExit: true } }}
                        expanded={expanded === `panel${machineIndex}`}
                        onChange={handleChange(`panel${machineIndex}`)}
                        id={`panel${machineIndex}`}
                        sx={{
                            background: 'transparent',
                            padding: '20px 0',
                            boxShadow: 'none',
                        }}
                    >
                        <ButtonBase sx={{width: '100%'}}>
                            <AccordionSummary
                                aria-controls={`panel${machineIndex}-content`}
                                id={`panel${machineIndex}-header`}
                                sx={{
                                    ":hover": {
                                        backgroundColor: palette.header.main
                                    },
                                    borderRadius: '10px'
                                }}
                            >
                                {expanded === `panel${machineIndex}` && <ExpandMoreIcon sx={{fontSize: '30px'}}/>}

                                <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%', cursor: 'pointer' }}>
                                    <FlexColumnDiv style={{
                                        borderLeft: `4px solid ${palette.main}`,
                                        borderRadius: '4px',
                                        minHeight: '100px',
                                        padding: '10px 20px 10px 20px',
                                        gap: '5px',
                                    }}>
                                        <span style={{ fontWeight: '650', fontSize: '20px', paddingLeft: '5px' }}>
                                            Machine {`${machineIndex + 1}`}
                                        </span>

                                        {expanded === `panel${machineIndex}` ?
                                            <FlexRowDiv style={{gap: '100px'}}>
                                                <FlexColumnDiv style={{gap: '5px'}}>
                                                    <LabelField
                                                        label={"Machine Name"}
                                                        value={machineEntry.machineName}
                                                        cursor="pointer"
                                                    />
                                                    <LabelField
                                                        label={"Machine Type"}
                                                        value={machineEntry.machineType}
                                                        cursor="pointer"
                                                    />
                                                </FlexColumnDiv>

                                                <FlexColumnDiv style={{gap: '5px'}}>
                                                    <LabelField
                                                        label={"Machine Description"}
                                                        value={machineDescription}
                                                        cursor="pointer"
                                                    />
                                                    <LabelField
                                                        label={"Diagnostic Can ID Rx"}
                                                        value={machineEntry.canDiagRxId}
                                                        cursor="pointer"
                                                    />
                                                </FlexColumnDiv>
                                            </FlexRowDiv>
                                            :
                                            <FlexRowDiv style={{gap: '100px'}}>
                                                <FlexColumnDiv style={{gap: '5px'}}>
                                                    <LabelField
                                                        label={"Machine Name"}
                                                        value={machineEntry.machineName}
                                                        cursor="pointer"
                                                    />
                                                    <LabelField
                                                        label={"Machine Type"}
                                                        value={machineEntry.machineType}
                                                        cursor="pointer"
                                                    />
                                                </FlexColumnDiv>

                                                <FlexColumnDiv style={{gap: '5px'}}>
                                                    <LabelField
                                                        label={"Machine Description"}
                                                        value={machineDescription}
                                                        cursor="pointer"
                                                    />
                                                    <LabelField
                                                        label={"Diagnostic Can ID Rx"}
                                                        value={machineEntry.canDiagRxId}
                                                        cursor="pointer"
                                                    />
                                                </FlexColumnDiv>
                                            </FlexRowDiv>
                                        }

                                        {fieldsWithErrorList[machineIndex] && fieldsWithErrorList[machineIndex].length > 0 &&
                                            <span style={{color: palette.stepper.error, paddingTop: '5px', marginLeft: '5px'}}>
                                                Validation errors found in one or more machine input fields
                                            </span>
                                        }
                                        {variantWithErrorList[machineIndex] && variantWithErrorList[machineIndex].length > 0 &&
                                            <span style={{color: palette.stepper.error, paddingTop: '5px', marginLeft: '5px'}}>
                                                Error in {variantWithErrorList[machineIndex].join(', ')}
                                            </span>
                                        }
                                        {clusterWithErrorList[machineIndex] && clusterWithErrorList[machineIndex].length > 0 &&
                                            <span style={{color: palette.stepper.error, paddingTop: '5px', marginLeft: '5px'}}>
                                                Error in {clusterWithErrorList[machineIndex].join(', ')}
                                            </span>
                                        }
                                        {criteriaWithErrorList[machineIndex] && criteriaWithErrorList[machineIndex].length > 0 &&
                                            <span style={{color: palette.stepper.error, paddingTop: '5px', marginLeft: '5px'}}>
                                                Error in {criteriaWithErrorList[machineIndex].join(', ')}
                                            </span>
                                        }
                                    </FlexColumnDiv>
                                </div>
                            </AccordionSummary>
                        </ButtonBase>

                        <AccordionDetails>
                            <VariantList
                                moduleInformation={moduleInformation}
                                machineList={machineList}
                                machineIndex={machineIndex}
                                setMachineList={setMachineList}
                                machineListErrors={machineListErrors}
                                setMachineListErrors={setMachineListErrors}
                                projectKey={projectKey}
                                moduleName={moduleName}
                            />
                        </AccordionDetails>
                    </Accordion>
                </HeaderDiv>
                )
            })}
        </div>
    );
}

export default MachineList;

